// https://developers.google.com/maps/documentation/javascript/place-autocomplete#constrain-place-types
export const GooglePlaceTypeFilter = {
  regions: ["(regions)"],
};
